import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import Chip from 'material-ui/Chip';
import { localize } from '../i18n';

const MultipleLocations = function MultipleLocations(props) {
  const {
    locations,
    noChips,
  } = props;

  const processLocationName = (item) => {
    if (item.location_type === 'guest_room') {
      return props.t('Room {itemLocationName}', { itemLocationName: item.location_name });
    }
    return item.location_name.toUpperCase();
  };

  let wrapperStyle = { display: 'flex', flexWrap: 'wrap' };
  let displayedLocations = null;
  if (noChips === true) {
    wrapperStyle = { display: 'inline' };
    displayedLocations = _.map(locations, (loc) => {
      const label = processLocationName(loc);
      return label;
    }).join(', ');
  } else {
    displayedLocations = _.map(locations, (loc, idx) => {
      const label = processLocationName(loc);
      return (
        <Chip key={`location-${idx}`} style={{ margin: '0 10px 10px 0' }}>{props.t(label)}</Chip>
      );
    });
  }
  return (
    <div style={wrapperStyle}>
      {displayedLocations}
    </div>
  );
};

MultipleLocations.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.any),
  noChips: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

MultipleLocations.defaultProps = {
  noChips: false,
};

export default localize(MultipleLocations);



// WEBPACK FOOTER //
// ./src/components/MultipleLocations.js